import { css } from "@emotion/css";

const styles = {
  addressItem: css`
    height: 80px;
  `,
};

export default styles;
